module.exports = __webpack_public_path__ + "img/badge.b0e6b2c2.svg";